import { type AxiosRequestConfig } from 'axios';

import { fetchApi, getSaviApiUrlLists, Logger } from '../../services';
import {
  type SampleDataApiRequest,
  type SampleDataAPIResponse,
} from '../types';

const { DATA_SAMPLE_URL } = getSaviApiUrlLists(false);

function isChatAskResponse(data: unknown): data is SampleDataAPIResponse {
  return typeof data === 'object' && data !== null && 'chatuuid' in data;
}

const callSampleDataApi = async (
  request: SampleDataApiRequest,
  url?: string
): Promise<Awaited<SampleDataAPIResponse>> => {
  const sampleDataUrl = url ?? DATA_SAMPLE_URL;

  const options: AxiosRequestConfig = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: request,
  };

  let response;

  try {
    response = await fetchApi<SampleDataAPIResponse>(
      sampleDataUrl,
      options,
      isChatAskResponse
    );
  } catch (error) {
    Logger.info(error);
    throw error;
  }

  return response;
};

export default callSampleDataApi;
